import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actionCreator from "../../../redux/action/actionCreator";
import Toast from "../../../components/MessageToast";
import FaqFormDialog from "../../components/forms/FaqsForm";
import { CREATE_FAQ, UPDATE_FAQ } from "../../../redux/faqs/types";
import { toast } from "react-toastify";
import { DISPLAY_ORDER_MIN } from "../../components/faq/faqOptions";

// Rendered as a Dialog directly on the FAQs list - not a routed page.
// `faq` (when editing) is the item object the list already has loaded, so
// no extra fetch-by-id round trip is needed before the form can open.
export default ({ open, faq, defaultDisplayOrder, onClose, onSaved }) => {
  const faqId = faq?.id;
  const dispatch = useDispatch();

  const operationStore = useSelector((store) =>
    faqId ? store.updateFaqGlobalStore : store.createFaqGlobalStore
  );
  const [state, setState] = useState({ openToast: false });

  const openToast = ({ message, type, onClose: onToastClose }) =>
    Toast({ message, type, duration: 3000, onClose: onToastClose });

  const handleFormSubmit = async (formData) => {
    const displayOrder = Number(formData.displayOrder);
    const missingFields = [];

    if (!formData.question?.trim()) {
      missingFields.push("Question");
    }
    if (!formData.answer?.trim()) {
      missingFields.push("Answer");
    }
    if (!Number.isInteger(displayOrder) || displayOrder < DISPLAY_ORDER_MIN) {
      missingFields.push("Display order");
    }

    if (missingFields.length > 0) {
      return openToast({
        message: `Please Enter All required fields \nMissing: ${missingFields.join(
          ", "
        )}`,
        type: "warning",
      });
    }

    const faqInfo = {
      question: formData.question.trim(),
      answer: formData.answer,
      displayOrder,
    };

    await toast.promise(
      dispatch(
        actionCreator({
          method: faqId ? "PATCH" : "POST",
          path: faqId ? `/api/faqs/${faqId}` : "/api/faqs",
          actionType: faqId ? UPDATE_FAQ : CREATE_FAQ,
          data: faqInfo,
        })
      ),
      {
        pending: `${!faqId ? "Creating" : "Updating"} FAQ`,
      }
    );

    setState({ ...state, openToast: true });
  };

  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () => {
        if (operationStore.message.includes("successful")) {
          onSaved();
        }
      },
    });

    setState({ ...state, openToast: false });
  }

  return (
    <FaqFormDialog
      open={open}
      onClose={onClose}
      isCreate={!faqId}
      title={`${faqId ? "Edit" : "Add"} FAQ`}
      onSubmit={handleFormSubmit}
      baseContentData={faq || {}}
      defaultDisplayOrder={defaultDisplayOrder}
      isLoading={operationStore.loading}
    />
  );
};
